import axios from 'axios';
import config from '../config';
import store from '@/store';

function create(data: any = {}) {
  const token = store.getters.getToken;
  return axios({
    method: 'post',
    url: '/transaction',
    baseURL: config.host,
    timeout: 50000,
    headers: {
      Authorization: `Bearer ${token}`,
    },
    data
  });
}

export default {
  create
};
